import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

// @Utility
import readMenuIcon from "@utility/app/readMenuIcon";
import { getStorage, cleatStorage, setStorage } from "@utility/app/storage";

// JWT & Auth
import { isUserLoggedIn } from "@core/auth/utils";

// Redux & Action
import { useDispatch, useSelector } from 'react-redux';
import { setDataAlert } from "@core/redux/actions/app/alert";
import { openAuthenApp } from "@core/redux/actions/auth/index";

// Component
import Drawer from '@mui/material/Drawer';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ImageShow from "views/components/ImageShow";
import Credit from "views/components/Credit";
import Point from "views/components/Point";

// Icon
import MenuIcon from '@mui/icons-material/Menu';
// import HomeIcon from '@mui/icons-material/Home';
// import HistoryIcon from '@mui/icons-material/History';
// import AccountBoxIcon from '@mui/icons-material/AccountBox';
// import StyleIcon from '@mui/icons-material/Style';

// Style & CSS
import "assets/css/Sidebar.css";

export default function Sidebar({ dataCms }) {
    const [state, setState] = useState({ right: false });
    const history = useNavigate();
    const dispatch = useDispatch();
    const homeData = useSelector(state => state.reduxHome.result);
    const [dataList, setDataList] = useState([]);

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const gotoPage = (page, pageName) => {
        if (page === "/bank" || page === "/history") {
            if (isUserLoggedIn()) {
                history(page);
            }
            else {
                openBox(pageName);
            }
        }
        else if (page === "/logout") {
            let market = getStorage("market")
            cleatStorage();
            setStorage("market", market)
            window.location.reload();
        }
        else {
            history(page);
        }
    };

    // const gotoProfile = (type, pageName) => {
    //     if (isUserLoggedIn()) {
    //         setOpenProfile(type);
    //     }
    //     else {
    //         openBox(pageName);
    //     }
    // };

    // const setOpenProfile = (type) => {
    //     dispatch(openProfile({ tab: "profile", show: true, type: type, button: false }));
    // };

    const openBox = (page) => {
        dispatch(setDataAlert({
            type: "warning",
            title: "แจ้งเตือน",
            text: `กรุณาเข้าสู่ระบบก่อนเข้าใช้งาน "${page}"`,
            action: true,
            redirect: "/login",
            show: true,
            buttonText: "ตกลง"
        }));
    };

    const openLogin = () => {
        let myObj = {
            tab: "login",
            show: true
        };

        dispatch(openAuthenApp(myObj));
    };

    const openRegister = () => {
        let myObj = {
            tab: "register",
            show: true
        };

        dispatch(openAuthenApp(myObj));
    };

    const renderContentProfile = () => (
        isUserLoggedIn() ?
            <div className="sidebarMenuList">
                <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={3}>
                        <div className="center">
                            <div className="boxUserPosition">
                                <img className="userSize" src="/images/icon/profile-all.webp" alt=" เว็บตรง ลิขสิทธิ์แท้ ไม่ผ่านเอเย่นต์ คาสิโน สล็อต กีฬา  ฝาก - ถอน ระบบอัตโนมัติ 24 ชม" />
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={9}>
                        <div className="usernameText">
                            {homeData !== null && (homeData.username)}
                        </div>
                    </Grid>
                </Grid>
                
                <div className="boxMarginTop">
                    <Credit width={84}></Credit>
                    <Point width={84}></Point>
                </div>
                <br />
            </div>
            :
            <div className="boxPaddibng center">
                <div className="sidebarMenuTitle">
                    สมาชิกใหม่ลุ้นรับของรางวัลมากมาย
                </div>
                <div className="sidebarMenuTextSub">
                    อยากสนุก ตื่นเต้น เร้าใจ สมัครเลย !
                </div>
                <br />
                <button className="btn btnNavbar btnHover btnWidthLarge btnRadius textBoldHight" onClick={openRegister}>
                    สมัครสมาชิก ตอนนี้
                </button>
                <br /> <br />
                <div className="sidebarMenuTextSub">
                    เป็นสมาชิกอยู่เเล้วใช่ หรือไม่ ? <span className="sidebarMenuLogin" onClick={openLogin}>เข้าสู่ระบบ</span>
                </div>
            </div>
    );

    const rederContent = (anchor) => (
        <div
            className="list"
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <div className="sidebarMenuPosition">
                <div>
                    {
                        renderContentProfile()
                    }
                </div>

                {
                    dataList.map((item, index) => (
                        (isUserLoggedIn() === item.login || item.login === false) && (
                            <div key={index} >
                                <Divider />
                                <div className="sidebarMenuList cursorPointer" onClick={() => { gotoPage(item.redirect) }}>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item>
                                            <div className="imgSidebarMenuCard">
                                                <ImageShow className="imgSidebarMenu" src={item.image} alt="เมนู สล็อตออนไลน์" />
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            {item.name}
                                        </Grid>
                                    </Grid>
                                </div>

                                {
                                    (dataList.length - 1) !== index && (
                                        <Divider />
                                    )
                                }
                            </div>
                        )
                    ))
                }
            </div>
        </div>
    );

    useEffect(() => {
        let menuList = [
            {
                "image": readMenuIcon(dataCms?.icon_home, "/images/icon/home.webp"),
                "name": "หน้าหลัก",
                "status": 1,
                "redirect": "/",
                "login": false
            },
            {
                "image": readMenuIcon(dataCms?.icon_wheel, "/images/icon/wheel.webp"),
                "name": "กงล้อลุ้นโชค",
                "status": 1,
                "redirect": "/wheel",
                "login": true
            },
            {
                "image": readMenuIcon(dataCms?.icon_event, "/images/icon/event.png"),
                "name": "กิจกรรม",
                "status": 1,
                "redirect": "/activity",
                "login": true
            },
            {
                "image": readMenuIcon(dataCms?.icon_profile, "/images/icon/profile.webp"),
                "name": "ข้อมูลผู้ใช้",
                "status": 1,
                "redirect": "/profile",
                "login": true
            },
            {
                "image": readMenuIcon(dataCms?.icon_promotion, "/images/icon/promotion.webp"),
                "name": "โปรโมชั่น",
                "status": 1,
                "redirect": "/promotion",
                "login": false
            },
            {
                "image": readMenuIcon(dataCms?.icon_affiliate, "/images/icon/aff.webp"),
                "name": "เชิญเพื่อน",
                "status": 1,
                "redirect": "/affiate",
                "login": true
            },
            {
                "image": readMenuIcon(dataCms?.icon_history, "/images/icon/history.webp"),
                "name": "ประวัติรายการ",
                "status": 1,
                "redirect": "/history",
                "login": true
            },
            {
                "image": readMenuIcon(dataCms?.icon_cashback, "/images/icon/cashback.webp"),
                "name": "รับทรัพย์",
                "status": 1,
                "redirect": "/cashback",
                "login": true
            },
            {
                "image": readMenuIcon(dataCms?.icon_repassword, "/images/icon/changePassword.webp"),
                "name": "เปลี่ยนรหัสผ่าน",
                "status": 1,
                "redirect": "/password",
                "login": true
            },
            {
                "image": readMenuIcon(dataCms?.icon_logout, "/images/icon/logOut.webp"),
                "name": "ออกจากระบบ",
                "status": 1,
                "redirect": "/logout",
                "login": true
            }
        ];

        setDataList(menuList);
    }, [dataCms]);

    return (
        <div className="Sidebar">
            <>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={toggleDrawer("right", true)}
                    edge="start"
                    className="btnToggleSize"
                >
                    <MenuIcon className="iconSideBarSize" />
                </IconButton>
            </>

            <Drawer anchor={"right"} open={state["right"]} onClose={toggleDrawer("right", false)}>
                {
                    rederContent("right")
                }
            </Drawer>
        </div>
    );
}